import React from 'react';

export interface DividerProps {
  className?: string;
}

export function Divider({ className = '' }: DividerProps) {
  return <div className={`h-px bg-slate-200 ${className}`} />;
}

